import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { ApiservicesService } from 'src/app/services/apiservices.service';
import { DynamicRitualPraxisChooseModal } from '../perennial-mandalism-dashboard/perennial-mandalism-dashboard.component';

@Component({
  selector: 'app-ritual-choose-modal',
  templateUrl: './ritual-choose-modal.component.html',
  styleUrls: ['./ritual-choose-modal.component.scss']
})
export class RitualChooseModalComponent {
  safeSrc: SafeUrl;
  
    public cookieData: any;
    public isLoading: boolean;
  
    constructor(
      public dialogRef: MatDialogRef<RitualChooseModalComponent>,
      public dialog: MatDialog,
      public router: Router,
      @Inject(MAT_DIALOG_DATA) public data: RitualChooseModalComponent,
      private apiservice: ApiservicesService, public matSnackBar: MatSnackBar,
      private sanitizer: DomSanitizer,
    ) {
      this.cookieData = this.data
    }
  
    onClickRitualButton(title: string) {
      if (title === "Planetary Zodiacal Invocation Ritual of the Pentagram") {
        const dialogRef = this.dialog.open(DynamicRitualPraxisChooseModal, {
          panelClass: ['custom-modalbox', 'dynamic-ritual-choose-modalbox'],
          data: {
            cookie: this.cookieData
          }
        });
        dialogRef.afterClosed().subscribe((result: any) => {
          console.log('The dialog was closed');
        });
  
        this.closeModal();
  
      } else {
        let tags: string[] = [];
  
        // STEP 1: Populate the tags array FIRST based on the title.
        if (title === "Standard Banishing Ritual of the Pentagram") {
          tags = ["Banishing_Ritual"];
        } else if (title === "Standard Invocation Ritual of the Pentagram") {
          tags = ["Invocation_Ritual"];
        } else if (title === "Divine Infinite Being Invocation Ritual of the Pentagram") {
          tags = ["Core_Invocation_Ritual"];
        }
        
        if (tags.length > 0) {
          this.isLoading = true;
          const endpoint = "ritual-invocation/add-ritual-configuration";
          const cookieDetails = this.cookieData;
  
          const payload = {
            user_id: cookieDetails.cookie.userinfo._id,
            ritual_tags: tags
          }
  
          this.apiservice.getHttpDataPost(endpoint, payload).subscribe({
            next: (response: any) => {
              this.isLoading = false;
              this.closeModal();
              const config_id = response.results._id;
              this.router.navigate(
                ['/perennial-mandalism-dashboard/ritual-result', config_id],
              );
            },
            error: (error: any) => {
              this.isLoading = false;
              this.matSnackBar.open('Failed to load ritual. Please try again.', 'Close', { duration: 3000 });
              console.error(error);
            },
          });
        }
      }
  }
  
    ngOnInit() {
      //console.log("cookie", this.cookieData);
    }
  
    public closeModal() {
      this.dialogRef.close();
    }
}
